import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-item-shuffle",
  templateUrl: "./ctrl-item-shuffle.component.html",
  styleUrls: ["./ctrl-item-shuffle.component.css"],
})
export class CtrlItemShuffleComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {}

  public onChangeShuffle() {
    this.itemChanged.emit({ item: this.item });
  }
}
